import Navbar from '../components/layout/Navbar';
import Footer from '../components/layout/Footer';
import PageHeader from '../components/ui/PageHeader';
import { FadeIn } from '../components/ui/AnimatedSection';
import AuditForm from '../components/forms/AuditForm';
import { useTranslation } from 'react-i18next';

export default function Audit() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen flex flex-col font-sans text-black-deep bg-cream-100">
      <Navbar />
      <PageHeader title={t('audit.heroTitle')} subtitle={t('audit.heroSubtitle')} imagePath="/assets/luxury_haussmann.webp" />

      <main className="flex-grow py-24">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <FadeIn>
            <div className="bg-white p-8 md:p-12 shadow-2xl border border-gold-200/50 rounded-sm">
              <AuditForm />
            </div>
          </FadeIn>
        </div>
      </main>
      <Footer />
    </div>
  );
}
